module.exports = __webpack_public_path__ + "img/signup-banner.ab625f2d.png";